/**
 * Analytics Library
 * Library interface to interact with Google Analytics library loaded elsewhere
 * version 1.1.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('gtm',[
    "jquery",
    "logging"
], function ($, logging) {
    "use strict";

    var _ModuleName = "Google Tag Manager";
    var _config = {
        enabled: true,
    }

    function init() {
        // Make sure gtm is enabled
        if(!_config.enabled) return;

        // initialize global vars as needed
        window.dataLayer = window.dataLayer || [];
        window.bnm = window.bnm || {};
        window.bnm.gtm = window.bnm.gtm || {};
        window.bnm.gtm.events = window.bnm.gtm.events || [];

        ;
    }

    var push = function(obj) {
        // Make sure gtm is enabled
        if(!_config.enabled) return;

        window.dataLayer.push(obj);
    }

    var fireEvent = function(name, category, action, label) {
        // Make sure gtm is enabled
        if(!_config.enabled) return;

        // check if event is being tracked globally
        var event = window.bnm.gtm.events.find(function(e) { return e.name == name; });
        if (event) {
            // if it is being tracked, check tracking to see if it has already been fired
            ;
            if (event.fired) {
                // if it has, log it and move on
                logging.warn("GTM Event was already fired for " + event.name + " and will not be fired again.", _ModuleName);
            } else {
                // if it has not, fire event
                ;
                event.fired = true;
                push(_buildEvent(name, category, action, label));
            }
        } else {
            // if it is not, fire event
            ;
            push(_buildEvent(name, category, action, label));
        }
    }

    var _buildEvent = function(name, category, action, label) {
        var evt = {
            'event': name
        };
        if (category) { evt.category = category; }
        if (action) { evt.action = action; }
        if (label) { evt.label = label; }
        return evt;
    }

    var setVariable = function(name, val) {
        // Make sure gtm is enabled
        if(!_config.enabled) return;

        var obj = {};
        obj[name] = val;
        push(obj);
    }

    return {
        init: init,
        push: push,
        fireEvent: fireEvent,
        setVariable: setVariable
    }
});
